import React from 'react'
import './Skills.css'
import c from './c.svg'
import logo from './react-2.svg'
import java from './java.svg'
import HTML from './html.svg'
import CSS from './css.svg'
import python from './python-5.svg'
import aws from './aws2.png'
import git from './git-icon.svg'
import js from './javascript.svg'

function Skills() {
  const skills = [
    { name: 'C/C++', icon: <img src={c} alt="C++" className="svg-icon"/>, size: 'large', position: { x: 10, y: 25 } },
    { name: 'Java', icon:  <img src={java} alt="Java" className="svg-icon"/>, size: 'large', position: { x: 30, y: 25 } },
    { name: 'HTML', icon:<img src={HTML} alt="HTML" className="svg-icon"/>, size: 'large', position: { x: 50, y: 25 } },
    { name: 'CSS', icon:<img src={CSS} alt="CSS" className="svg-icon"/>, size: 'large', position: { x: 70, y: 20 } },
    { name: 'Python', icon: <img src={python} alt="python" className="svg-icon"/>, size: 'large', position: { x: 20, y: 70 } },
    { name: 'React', icon:<img src={logo} alt="Logo" className="svg-icon"/> , size: 'large', position: { x: 40, y: 60 } },
    { name: 'JavaScript', icon: <img src={js} alt="JavaScript" className="svg-icon"/>, size: 'large', position: { x: 60, y: 65 } },
    { name: 'AWS', icon: <img src={aws} alt="AWS" className="svg-icon"/>, size: 'large', position: { x: 5, y: 80 } },
    { name: 'Git', icon: <img src={git} alt="Git" className="svg-icon"/>, size: 'large', position: { x: 75, y: 65 } }
  ]

  return (
    <div className="skills-container">
      <h1>My Skills</h1>
      
      {/* Asteroid Field */}
      <div className="asteroid-field">
        {skills.map((skill, index) => (
          <div 
            key={skill.name}
            className={`asteroid asteroid-${skill.size}`}
            style={{
              '--delay': `${index * 0.5}s`,
              '--rotation': `0deg`,
              '--x': `${skill.position.x}%`,
              '--y': `${skill.position.y}%`
            }}
          >
            <div className="skill-icon">{skill.icon}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Skills